module.exports = __webpack_public_path__ + "img/pleatcurtain.5e62b653.png";